import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { AlertService } from "../_services/alert.service";
import { DataService } from "../_services/data.service";

@Component({
  moduleId: module.id,
  selector: "brotherspanel",
  templateUrl: "brotherspanel.component.html",
  styleUrls: ["brotherspanel.component.scss"],
})
export class BrothersPanelComponent implements OnInit {
  @Input() brothersData: any;
  @Input() suggestChildrenIds?: number[] = [];
  @Input() type: number; // -1 denied,0 requested, 1 approved, 100 suggested
  @Output() shouldReload = new EventEmitter<boolean>();
  messages: any;
  brothers: any;
  loading: boolean = false;

  // 	checkAllBrothers: boolean = false;

  constructor(
    private alertService: AlertService,
    private dataService: DataService
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  changedCheckAll(evt) {
    let checked = evt.target.checked;

    if (this.brothers && this.brothers.length && this.brothers.length > 0) {
      this.brothers.forEach((b) => {
        b.checked = checked;
      });
    }
  }

  saveBrothers() {
    this.alertService.clear();
    let newBrothers = [];
    if (this.brothers && this.brothers.length && this.brothers.length > 0) {
      this.brothers.forEach((b) => {
        if (b.checked) {
          newBrothers.push(b);
        }
      });
      if (newBrothers && newBrothers.length && newBrothers.length > 1) {
        this.loading = true;
        this.dataService.saveBrothers(newBrothers).subscribe(
          (data) => {
            this.loading = false;
            this.shouldReload.emit();
          },
          (error) => {
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.messages[body.statusText]
                  ? this.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
            this.loading = false;
          }
        );
      } else {
        this.alertService.error("חייב לבחור לפחות 2 אחים");
      }
    }
  }

  ngOnInit() {
    if (this.brothersData) {
      //suggestions
      let bChildren = [];
      if (this.type == 100 && this.brothersData.children) {
        //
        for (let key in this.brothersData.children) {
          //
          bChildren.push(this.brothersData.children[key]);
        }
      }
      //everything else
      else {
        for (let key in this.brothersData) {
          if (this.brothersData[key] && this.brothersData[key].children) {
            for (let keyChild in this.brothersData[key].children) {
              bChildren.push(this.brothersData[key].children[keyChild]);
            }
          }
        }
      }

      this.brothers = bChildren;
      if (this.suggestChildrenIds.length) {
        this.brothers.forEach((b) => {
          if (this.suggestChildrenIds.includes(b.childId)) {
            b.checked = true;
          }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/brothers/brotherspanel.component.ts